import { render, staticRenderFns } from "./CustomEmojiPicker.vue?vue&type=template&id=9412413a"
import script from "./CustomEmojiPicker.vue?vue&type=script&lang=js"
export * from "./CustomEmojiPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports